export default function (value) {
  if (value === null || typeof value === 'undefined' || typeof value === 'string' && value.trim() == '') {
    return false;
  }

  return value === 0 || !!value;
};
